import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'
export const catalogAdminExtractionModelsAccessConfiguration: DomainAccessControlConfig = {
  permissions: Permission.CatalogDetectionViewAccess,
}

export const catalogAdminExtractionModelsEditAccessConfiguration: DomainAccessControlConfig = {
  permissions: [Permission.CatalogDetectionViewAccess, Permission.CatalogDetectionModifyAccess],
}

export const showCampPipelineEditor: DomainAccessControlConfig = {
  featureToggles: [FeatureToggle.ShowCampPipelineEditor],
}

export const showStructuredInput: DomainAccessControlConfig = {
  featureToggles: [FeatureToggle.ShowStructuredInput],
}
